import React from "react";

const CPP_Intro = () => {
  return (
    <div>
      <h1>CPP_Intro Component</h1>
      <p>Content for CPP_Intro goes here...</p>
    </div>
  );
};

export default CPP_Intro;
